module.exports = __webpack_public_path__ + "img/guide-company-register.1fa250b4.png";